import { render, staticRenderFns } from "./SocialLoginLinkAccountModal.vue?vue&type=template&id=21e0fed9&scoped=true"
import script from "./SocialLoginLinkAccountModal.vue?vue&type=script&lang=js"
export * from "./SocialLoginLinkAccountModal.vue?vue&type=script&lang=js"
import style0 from "./SocialLoginLinkAccountModal.vue?vue&type=style&index=0&id=21e0fed9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0fed9",
  null
  
)

export default component.exports